import React, { useContext } from "react";
import * as styles from "./style.mod.scss";
import {
  removeCartItems, updateCartItem,
  addCartItem, fetchCart
} from "data/cart";
import Money from "components/money";
import translations from "locales";
import GlobalContext from "services/global-context";
import { trackAddToCart, trackRemoveFromCart } from "helpers/analytics";

const CartItem = ({ item }) => {
  const { refreshCart, setLoadingVisible, cartSettings } = useContext(GlobalContext);

  const concatDetails = (dtls) =>
    dtls
      .filter((dtl) => dtl.value !== "Default Title")
      .map((dtl) => dtl.value)
      .join(" | ");

  const cartLoc = translations.cart;
  const updateCart = async (variant, qty, inc) => {
    setLoadingVisible(true);
    await updateCartItem(variant.id, qty);

    if (cartSettings?.giftProduct?.id) {
      const cart = await fetchCart();
      const totalPrice = +cart?.totalPriceV2?.amount;
      const freeVariantId = atob(cartSettings?.giftProduct?.id);
      const freeVariantInCart = cart?.items?.find(c => freeVariantId?.includes(c?.variantId));
      const excludedProducts = ["gid://shopify/Product/8331860377865", "gid://shopify/Product/8331862868233", "gid://shopify/Product/8331284349193"];
      const excludedProductsInCart = cart?.items?.find(c => excludedProducts.includes(c.productId));

      if (!freeVariantInCart && totalPrice > cartSettings?.giftThreshold && !excludedProductsInCart) {
        await addCartItem(freeVariantId);
      }
    }

    refreshCart();

    inc ?
      trackAddToCart({
        products: variant, qty, shopifyData: "shopify"
      }) :
      trackRemoveFromCart({
        products: variant, qty, shopifyData: "shopify"
      });
  };

  const removeFromCart = async (variant) => {
    setLoadingVisible(true);
    await removeCartItems([variant.id]);
    refreshCart();
    trackRemoveFromCart({
      products: variant, qty: 0, shopifyData: "shopify"
    });
  };

  return (
    <div key={item.id} className={styles.item}>
      <img className={styles.image} alt={item?.image?.altText} src={item?.image?.src} />
      <div className={styles.description}>
        <span className={styles.name}>{item?.title}</span>
        {concatDetails(item?.variantOptions) && (
          <span className={styles.details}>{concatDetails(item?.variantOptions)}</span>
        )}
        {item?.productTitle === "Helfer Set - 5" && (
          <span className={styles.details}>Olavson&apos;s Geschenk zum 5. Geburtstag</span>
        )}
        <div className={styles.pricesBox}>
          <span className={styles.price}>
            {(item?.qtyCompPrice > 1 || item?.discount?.amount > 0) &&
              <span className={styles.qtyCompPrices}>
                <Money value={item?.qtyCompPrice || item?.qtyPrice} />
              </span>}
          </span>
          <span className={styles.price}>
            <Money value={item?.salePrice} showZero />
          </span>

        </div>

        <div className={styles.qtyPrice}>
          <span className={styles.increment}>
            <span className={styles.dec}
              onClick={() => updateCart(item, --item.quantity)}>-</span>
            <span className={styles.val}>{item.quantity}</span>
            <span className={styles.inc}
              onClick={() => updateCart(item, ++item.quantity, "inc")}>+</span>
          </span>
        </div>
        <a className={styles.removeIcon}
          onClick={() => removeFromCart(item)}>
          {cartLoc?.remove}
        </a>
      </div>
    </div>
  );
};

export default CartItem;